import React from "react";
import "./index.css";

class Hero extends React.Component {
  handleScroll = (e) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute("href") || "";
    const targetId = href.replace("#", "");
    const element = document.getElementById(targetId);

    if (element) {
      const yOffset = -60; // Adjusted for reduced navbar height
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  render() {
    return (
      <section id="home" className="hero-section">
        {/* Advanced Background Effect */}
        <div className="hero-background">
          {/* Animated gradient elements */}
          <div className="hero-bg-animation">
            {/* Top left gradient */}
            <div className="hero-gradient hero-gradient-topleft"></div>

            {/* Bottom right gradient */}
            <div className="hero-gradient hero-gradient-bottomright"></div>

            {/* Center gradient */}
            <div className="hero-gradient hero-gradient-center"></div>
          </div>

          {/* Modern gradient overlay */}
          <div className="hero-gradient-overlay"></div>

          {/* Background image with blur effect */}
          <div className="hero-bg-image">
            <img
              src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
              alt="Business collaboration"
            />
          </div>
        </div>

        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-text-container">
              <span className="hero-tag">W.L.W. Enterprise</span>

              <h1 className="hero-title">
                Uplifting Our Community to{" "}
                <span className="hero-title-highlight">
                  Prosper
                  <span className="hero-title-underline"></span>
                </span>
              </h1>

              <p className="hero-subtitle">
                Integrated Solutions for Sustainable Development
              </p>

              <p className="hero-description">
                At W.L.W. Enterprise, we deliver integrated services—from
                education and behavioral health to childcare, real estate, and
                events—that drive growth, stability, and lasting impact. Our
                collaborative model empowers individuals and revitalizes
                Youngstown and the Mahoning Valley.
              </p>

              <div className="hero-buttons">
                <a
                  href="#services"
                  onClick={this.handleScroll}
                  className="hero-button hero-button-primary"
                >
                  <span className="hero-button-highlight"></span>
                  <span className="hero-button-overlay"></span>
                  <span className="hero-button-text">
                    Explore Our Services
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="hero-button-icon"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </span>
                </a>

                <a
                  href="#appointment"
                  onClick={this.handleScroll}
                  className="hero-button hero-button-secondary"
                >
                  <span className="hero-button-secondary-overlay"></span>
                  <span className="hero-button-text">
                    Schedule a Consultation
                  </span>
                </a>
              </div>
            </div>

            <div className="hero-image-container">
              <div className="hero-image-wrapper">
                {/* Animated decorative elements */}
                <div className="hero-image-gradient hero-image-gradient-1"></div>
                <div className="hero-image-gradient hero-image-gradient-2"></div>

                {/* Main Image */}
                <div className="hero-main-image-wrapper">
                  <div className="hero-main-image-overlay"></div>
                  <img
                    src="Images/Hero Image.avif"
                    alt="Business success"
                    className="hero-main-image"
                  />

                  <div className="hero-main-image-caption">
                    <div className="hero-caption-indicator">
                      <div className="hero-indicator-dot"></div>
                      <span className="hero-indicator-text">
                        Driving Business Innovation
                      </span>
                    </div>
                  </div>
                </div>

                {/* Floating accent elements */}
                {/* <div className="hero-accent-element">
                  <div className="hero-accent-content">
                    <div className="hero-accent-icon-wrapper">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="hero-accent-icon"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                        />
                      </svg>
                    </div>
                    <div className="hero-accent-text">
                      <p className="hero-accent-label">Growth Rate</p>
                      <p className="hero-accent-value">+124%</p>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          {/* Modern scroll indicator and bottom logo text arranged vertically */}
          <div className="hero-scroll-indicator">
            <span className="hero-scroll-text">SCROLL TO EXPLORE</span>
            <div className="hero-scroll-mouse">
              <div className="hero-scroll-dot"></div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Hero;
